import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import {
  Box,
  Typography,
  Button,
  Paper,
  TextField,
  Grid,
  DialogContent,
  Dialog,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import useErrorHandler from "../../hooks/useErrorHandler";
import { useNavigate, useParams } from "react-router-dom";
import {
  getAllColumns,
  getReportsByListName,
  getReportsByReportName,
} from "../../api/reports.js";
import { ReportsViewTable } from "../../config/grid-column-defs.js";
import { Visibility } from "@mui/icons-material";
import { getDownloadDocument } from "../../api/file-cabinet.js";
import { renderTAbNavigator } from "../../config/grid-value-formatters.js";
import { getTransSalesOrderDownloadCommFile } from "../../api/transaction-type.js";
import { getTransactionDownloadfile } from "../../api/invoice.js";

export default function ViewList() {
  const dispatch = useDispatch();
  const errorHandler = useErrorHandler();
  const snackbar = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();
  const { data: user } = useSelector((state) => state.user);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [columnNames, setAllColumnNames] = useState([]);
  const [reportViewTableColumns, setReportViewTableColumns] = useState([]);
  const [onInputSearch, setInputSearch] = useState({});
  const [nameSearchInputValue, setNameSearchValue] = useState("");
  const [idSearchInputValue, setIDSearchValue] = useState("");
  const [subsidiarySearchInputValue, setSubsidiarySearchValue] = useState("");
  const [percentComplete, setPercentComplete] = useState(0);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  let obj = ReportsViewTable.find((o) => o.headerName === "View");

  if (
    params.tableName === "lists_vendors" ||
    params.tableName === "lists_clients" ||
    params.tableName === "lists_projects"
  ) {
    addAdditionalColumnDownload(obj, navigate);
  } else {
    ReportsViewTable.splice(0, 1);
  }

  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }

  useEffect(() => {
    if (onInputSearch.length >= 3) {
      refreshTable();
    }
  }, [onInputSearch]);

  const getDownloadDocumentById = (id, filename, folder) => {
    setPercentComplete(0);

    const options = {
      headers: {
        authorization: user?.token,
      },
      responseType: "blob",
      onDownloadProgress: function (progressEvent) {
        const newPercentComplete = Math.floor(
          (progressEvent.loaded / progressEvent.total) * 100
        );

        console.log(
          "percentage====",
          progressEvent.loaded,
          progressEvent.total
        );
        setPercentComplete(newPercentComplete); // Update the percentComplete state
      },
    };
    setDownloadInProgress(true); // Start the download progress
    getTransactionDownloadfile(
      // { id: id },

      options,

      { filename: filename, folderpath: folder }
    )
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob.data);
        link.setAttribute("download", `${filename.replace(".html",".pdf")}`);
        document.body.appendChild(link);
        link.click();
        setDialogOpen(false);
      })
      .catch((err) => {
        errorHandler(err);
        setDownloadInProgress(false);
        setDialogOpen(false);
      })
      .finally(() => {
        setDownloadInProgress(false);
        setDialogOpen(false);
        // Download completed or errored, stop progress
      });
  };

  async function getReportsListByReportNameData(limit, offset) {
    try {
      const { data } = await getReportsByListName(
        user?.token,
        onInputSearch
          ? {
              limit,
              offset,
              list_name: params.tableName,
              ...onInputSearch,
            }
          : {
              limit,
              offset,
              report_name: params.tableName,
            }
      );
      const columns = await getAllColumnList();
      const dynamicColumns = generateDynamicColumns(
        //columns,
        data.Reportdata.ReportColumns,
        data.Reportdata.data
      );
      if (reportViewTableColumns.length === 0) {
        setReportViewTableColumns(dynamicColumns);
      }
      return {
        rows: data.Reportdata.data,
        total: data.Reportdata.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    }
  }

  async function getAllColumnList() {
    try {
      const { data } = await getAllColumns(user.token, {
        col_name: "",
        limit: "",
        offset: "",
      });
      setAllColumnNames(data.data.ColumnsList);
      return data.data.ColumnsList;
    } catch (error) {
      errorHandler(error);
    }
  }

  function generateDynamicColumns(allColumns, reportColumns) {
    const staticColumns = ReportsViewTable;
    const dynamicColumns = allColumns
      .filter((c) =>
        reportColumns.some((obj) => Object.keys(obj).includes(c.column_name))
      )
      .map((column) => {
        const headerText = column.column_name.toUpperCase();
        const textWidth = getTextWidth(headerText, "bold 14px Arial");
        const minWidth = Math.max(200, textWidth + 18);
        const isFileNameColumn = column.column_name === "File_Name";
        return {
          headerName: headerText,
          field: column.column_name,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          cellClass: "pmt-ag-cell-font capitalizeNone",
          minWidth,
          cellRendererFramework: isFileNameColumn ? renderTAbNavigator : null,
        };
      });

    // Combine static and dynamic columns
    return [...staticColumns, ...dynamicColumns];
  }

  // Function to measure text width
  function getTextWidth(text, font) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = font;
    const width = context.measureText(text).width;
    return width;
  }
  function tableNameClick(id) {
    console.log("params1click---", params.tableName);
    navigate("/lists/" + `${params.tableName}` + "/" + `${id}`);
    window.location.reload();
  }

  function addAdditionalColumnDownload(obj, navigate) {
    if (obj === undefined) {
      ReportsViewTable.unshift({
        headerName: "View",
        field: "actions",
        maxWidth: 200,
        minWidth: 100,
        cellClass: "downloadCenter",
        cellRendererFramework: (params) => (
          <Button
            className="actionIcon"
            onClick={() => {
              console.log("params---", params);
              tableNameClick(params?.data?.internal_id);
              // navigate(`${params?.data?.internal_id}`);
            }}
          >
            <Visibility />
          </Button>
        ),
      });
    }
  }

  useEffect(() => {
    setInputSearch({});
    handleReset();
  }, [params.tableName]);

  const handleReset = (e) => {
    setInputSearch({});
    setNameSearchValue("");
    setIDSearchValue("");
    setSubsidiarySearchValue("");
  };

  const onNameInputSearch = (event) => {
    setNameSearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, name: event.target.value });
  };

  const onSubsidiaryInputSearch = (event) => {
    setSubsidiarySearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, prjt_sub: event.target.value });
  };
  const onIDInputSearch = (event) => {
    setIDSearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, id: event.target.value });
  };
  return (
    <Box className="viewBox">
      <Box className="viewDetilsBox">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          // pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Lists Detail
          </Typography>
        </Box>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={4500} className="pageHeading1">
            {params.tableName.replace(/[_]/g, " ")}
          </Typography>
          <Button
            size="small"
            variant="contained"
            className="backBtn"
            onClick={() => navigate("/lists")}
          >
            Go Back
          </Button>
        </Box>
        {/* {params.tableName === "lists_vendors" || params.tableName === "lists_clients" ?
        <Box className="filter-box">
          <Grid container>
            <Grid item md={3} sm={4} xs={10}>
              <TextField
                autoComplete="off"
                placeholder={"Name"}
                size="small"
                label=""
                name={"name"}
                variant="outlined"
                value={nameSearchInputValue}
                onChange={onNameInputSearch}
                fullWidth
              />
            </Grid>
            <Grid item md={2} sm={2} xs={2}>
              <Button
                size="small"
                type="button"
                style={{ color: "black", marginTop: "4px" }}
                onClick={(e) => handleReset(e)}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </Box>
        : params.tableName === "lists_projects" ?
          <Box className="filter-box">
            <Grid container  spacing={{ sm: 2, md: 2 }}>
              <Grid item md={3} sm={4} xs={12}>
                <TextField
                  autoComplete="off"
                  placeholder={"Name"}
                  size="small"
                  label=""
                  name={"name"}
                  variant="outlined"
                  value={nameSearchInputValue}
                  onChange={onNameInputSearch}
                  fullWidth
                />
              </Grid>
              <Grid item md={3} sm={4} xs={12}>
                <TextField
                  autoComplete="off"
                  placeholder={"Subsidiary"}
                  size="small"
                  label=""
                  name={"prjt_sub"}
                  variant="outlined"
                  value={subsidiarySearchInputValue}
                  onChange={onSubsidiaryInputSearch}
                  fullWidth
                />
              </Grid>
              <Grid item md={2} sm={2} xs={2}>
                <Button
                  size="small"
                  type="button"
                  style={{ color: "black", marginTop: "4px" }}
                  onClick={(e) => handleReset(e)}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </Box>
          : <></>
      } */}
        {params.tableName === "list_customer_with_attachments" ||
        params.tableName === "list_pc_projects_with_attachments" ||
        params.tableName === "list_vendors_with_attachments" ? (
          <Box className="filter-box">
            <Grid container>
              <Grid item md={3} sm={4} xs={10}>
                <TextField
                  autoComplete="off"
                  placeholder={"ID"}
                  size="small"
                  label=""
                  name={"id"}
                  variant="outlined"
                  value={idSearchInputValue}
                  onChange={onIDInputSearch}
                  fullWidth
                />
              </Grid>
              <Grid item md={3} sm={4} xs={10} sx={{ ml: 2 }}>
                <TextField
                  autoComplete="off"
                  placeholder={"Name"}
                  size="small"
                  label=""
                  name={"name"}
                  variant="outlined"
                  value={nameSearchInputValue}
                  onChange={onNameInputSearch}
                  fullWidth
                />
              </Grid>

              {(nameSearchInputValue || idSearchInputValue) && (
                <Grid item md={2} sm={2} xs={2} style={{ margin: "0px 10px" }}>
                  <Button
                    size="small"
                    type="button"
                    style={{ color: "black", marginTop: "4px" }}
                    onClick={(e) => handleReset(e)}
                  >
                    Reset
                  </Button>
                </Grid>
              )}
            </Grid>
          </Box>
        ) : (
          <></>
        )}
        <Paper elevation={3} className="styleWordBreak">
          <AgGridPaginatedTable
            getTableRows={getReportsListByReportNameData}
            columns={reportViewTableColumns}
            perPage={10}
            refreshCounter={tableRefreshCount}
            onInputSearch={onInputSearch}
            onCellClicked={(params) => {
              console.log("Prarams-===", params);
              if (params.colDef.field === "File_Name") {
                setDialogOpen(true);

                getDownloadDocumentById(
                  params.data.id,
                  params.data.File_Name,
                  params.data.folder
                );
              }
              return;
            }}
          />
        </Paper>
        <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
          <DialogTitle>Download Progress</DialogTitle>
          <DialogContent>
            {downloadInProgress ? (
              <>
                <CircularProgress
                  variant="indeterminate"
                  value={percentComplete}
                  size={50}
                  thickness={10}
                  style={{ marginLeft: "65px" }}
                />
                <Box
                  sx={{
                    marginTop: 2,
                    textAlign: "center",
                    fontSize: "16px",
                    color: "#333",
                    "&:hover": {
                      color: "#1976d2",
                      cursor: "pointer",
                    },
                  }}
                >
                  <span>Please wait...</span>
                </Box>
              </>
            ) : (
              <></>
            )}
          </DialogContent>
          {/* Add dialog actions here if needed */}
        </Dialog>
      </Box>
    </Box>
  );
}
